// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__28Dwo","itemTitle":"ClientEmergencyInfo_itemTitle__3mEG9","itemText":"ClientEmergencyInfo_itemText__3oYuB"};